import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper'
import 'swiper/swiper-bundle.css'


Swiper.use([Autoplay, Pagination, EffectFade])

const partners = new Swiper('.partners__caroussel', {
  loop: true,

  autoplay: {
    enabled: true,
    delay: 2000,
  },

  spaceBetween: 24,
  slidesPerView: 2,
  slidesPerGroup: 2,

  pagination: {
    enabled: true,
    el: '.partners__pagination',
  },

  breakpoints: {
    768: {
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    1024: {
      enabled: false,
      slidesPerView: 5,
    },
  },
})

partners


// WEBPACK FOOTER //
// ./scripts/components/partners.js